import { ReactElement } from 'react';
import {
  Create,
  CreateProps,
  Edit,
  EditProps,
  ListButton,
  Show,
  ShowProps,
  TopToolbar
} from 'react-admin';

function ActionListButton() {
  return (
    <TopToolbar>
      <ListButton />
    </TopToolbar>
  );
}

function formWrapper<T extends typeof Create | typeof Edit | typeof Show>(
  props:
    | (T extends typeof Create ? CreateProps & { children: ReactElement } : any)
    | (T extends typeof Edit ? EditProps & { children: ReactElement } : any)
    | (T extends typeof Show ? ShowProps & { children: ReactElement } : any)
): (WrappedComponent: any) => ReactElement {
  return WrappedComponent => (
    <WrappedComponent actions={<ActionListButton />} {...props} />
  );
}

export default formWrapper;
